import * as ModalTypes from '@components/App/Modal/constants'
import type { UpgradePlanActions } from '@store/reducers/upgradePlan'
import * as ActionTypes from '@storeOld/actions'
import { put } from 'redux-saga/effects'

export function* redirect({
  payload: { planId },
}: ReturnType<typeof UpgradePlanActions.redirect>) {
  const redirectAfterAuth = `/subscription/checkout/?planId=${planId}&planType=annual`

  yield put({
    type: ActionTypes.OPEN_MODAL,
    payload: {
      modalType: ModalTypes.MODAL_AUTH,
      modalProps: { authType: 'signup', redirectAfterAuth },
    },
  })
}
